import type { FieldValues } from 'react-hook-form';

export const extractMessage = (obj: unknown): string | undefined => {
  if (!obj || typeof obj !== 'object') return undefined;

  const record: FieldValues = obj;

  if (typeof record.message === 'string') return record.message;

  for (const value of Object.values(record)) {
    const result = extractMessage(value);

    if (result !== undefined) return result;
  }

  return undefined;
};

export const scrollToFirstFormErrorOccurrence = () => {
  const target =
    document.querySelector('.Mui-error') ??
    document.querySelector('.MuiAlert-standardError') ??
    document.querySelector('.MuiAlert-colorError') ??
    document.querySelector('[aria-invalid="true"]');

  if (target) {
    target.scrollIntoView({ behavior: 'smooth' });

    return true;
  }

  return false;
};

export const scrollToFirstErrorMessage = (errors: FieldValues = {}) => {
  const elements = document.querySelectorAll('.MuiTypography-root');
  const elementsArray = [...elements];

  for (const err in errors) {
    const targetMessage = extractMessage(errors[err]);

    if (!targetMessage) continue;

    const errorElement = elementsArray.find(el => (el.textContent ?? '').includes(targetMessage));

    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth' });

      return;
    }
  }
};

export const scrollToError = (errors: FieldValues = {}) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const scrolled = scrollToFirstFormErrorOccurrence();

      // fallback if error is implemented in a non-standard way
      // or error is a banner shown after api validation
      if (!scrolled) scrollToFirstErrorMessage(errors);
    });
  });
};
